import{
    SUBMIT_REQUEST,
    SUBMIT_SUCCESS,
    SUBMIT_FAIL,
    SUBMIT_RESET,
} from "../constants/submitConstants";


const initialState = {
  loading: false,
  error: null,
  success: false,
  dailyStatus: {},
};
export const submitReducer = (state = initialState, action) =>{
    switch (action.type) {
        case SUBMIT_REQUEST:
          return { ...state, loading: true };
        case SUBMIT_SUCCESS:
          return { loading: false, success:true, dailyStatus: action.payload };
        case SUBMIT_FAIL:
          return { loading: false, error: action.payload };
        case SUBMIT_RESET:
          return initialState;
        default:
          return state;

}
};